import { Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// Layout
import Layout from './components/layout/Layout'

// Pages
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import GroupCompanies from './pages/GroupCompanies'
import Projects from './pages/Projects'
import Careers from './pages/Careers'
import Contact from './pages/Contact'
import Industries from './pages/Industries'
import MediaCenter from './pages/MediaCenter'
import Franchise from './pages/Franchise'

// GSAP Plugins
gsap.registerPlugin(ScrollTrigger)

function App() {
  useEffect(() => {
    // Refresh ScrollTrigger on resize
    const handleResize = () => {
      ScrollTrigger.refresh()
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="services/*" element={<Services />} />
        <Route path="group-companies" element={<GroupCompanies />} />
        <Route path="projects" element={<Projects />} />
        <Route path="careers" element={<Careers />} />
        <Route path="contact" element={<Contact />} />
        <Route path="industries" element={<Industries />} />
        <Route path="media-center" element={<MediaCenter />} />
        <Route path="franchise" element={<Franchise />} />
      </Route>
    </Routes>
  )
}

export default App